// config/configFields.js
export const smsConfigFields = [
  {
    label: "SMS Provider",
    name: "sms_provider_id",
    type: "select",
    placeholder: "Select Sub Category",
    isSelect: true,
  },
  {
    label: "SMS From",
    name: "sms_from",
    type: "text",
  },
  {
    label: "API Auth Key",
    name: "sms_api_key",
    type: "text",
  },
  {
    label: "API Secret",
    name: "sms_api_secret",
    type: "text",
  },
];

export const emailConfigFields = [
  { label: "Mail Type", name: "mail_type", type: "text" },
  { label: "Mail Driver", name: "mail_driver", type: "text" },
  { label: "Mail Host", name: "mail_host", type: "text" },
  { label: "Mail Port", name: "mail_port", type: "number" },
  { label: "Mail Username", name: "mail_username", type: "text" },
  { label: "Mail Password", name: "mail_password", type: "password", isPassword: true },
  { label: "Mail Encryption", name: "mail_encryption", type: "text" },
  { label: "Mail From", name: "mail_from", type: "text" },
];
